"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionEndpoint = void 0;
const Errors_1 = require("./Errors");
exports.ExceptionEndpoint = 'https://statsigapi.net/v1/sdk_exception';
class ErrorBoundary {
    constructor(sdkKey) {
        this.seen = new Set();
        this.sdkKey = sdkKey;
    }
    setStatsigMetadata(statsigMetadata) {
        this.statsigMetadata = statsigMetadata;
    }
    swallow(tag, task) {
        this.capture(tag, task, () => {
            return undefined;
        });
    }
    capture(tag, task, recover, getExtraData) {
        try {
            const result = task();
            if (result instanceof Promise) {
                return result.catch((e) => {
                    return this.onCaught(tag, e, recover, getExtraData);
                });
            }
            return result;
        }
        catch (error) {
            return this.onCaught(tag, error, recover, getExtraData);
        }
    }
    onCaught(tag, error, recover, getExtraData) {
        if (error instanceof Errors_1.StatsigUninitializedError ||
            error instanceof Errors_1.StatsigInvalidArgumentError) {
            throw error; // Don't catch these
        }
        console.error('[Statsig] An unexpected exception occurred.', error);
        this.logError(tag, error, getExtraData);
        return recover();
    }
    async logError(tag, error, getExtraData) {
        var _a;
        try {
            const extra = typeof getExtraData === 'function' ? await getExtraData() : null;
            const unwrapped = (error !== null && error !== void 0 ? error : Error('[Statsig] Error was empty'));
            const isError = unwrapped instanceof Error;
            const name = isError ? unwrapped.name : 'No Name';
            if (this.seen.has(name))
                return;
            this.seen.add(name);
            const info = isError ? unwrapped.stack : this.getDescription(unwrapped);
            const metadata = (_a = this.statsigMetadata) !== null && _a !== void 0 ? _a : {};
            const body = JSON.stringify({
                tag,
                exception: name,
                info,
                statsigMetadata: metadata,
                extra: extra !== null && extra !== void 0 ? extra : {},
            });
            fetch(exports.ExceptionEndpoint, {
                method: 'POST',
                headers: {
                    'STATSIG-API-KEY': this.sdkKey,
                    'STATSIG-SDK-TYPE': String(metadata['sdkType']),
                    'STATSIG-SDK-VERSION': String(metadata['sdkVersion']),
                    'Content-Type': 'application/json',
                    'Content-Length': `${body.length}`,
                },
                body,
            });
        }
        catch (_error) {
            /* noop */
        }
    }
    getDescription(obj) {
        try {
            return JSON.stringify(obj);
        }
        catch {
            return '[Statsig] Failed to get string for error.';
        }
    }
}
exports.default = ErrorBoundary;
